module.exports = __webpack_public_path__ + "static/media/08.Foreign Tour.8337fe92.jpg";